<template>
    <section>
        <section class="w-80 mx-auto services">
            <header class="section-heading">
                <h3 class="orange-color">Our Services</h3>
            </header>
            <section>
                <p><strong>Nutron</strong> is an Authorised Apple Service Provider. We can provide you with warranty repairs
                    for the entire
                    Apple product range including but not limited to Apple computers, iPads, iPhones and iPods. We are also
                    your authorised service providers for your precious Beats range.
                    You are welcome to pop into our store for any of your service needs at 678 Colombo Street, Christchurch
                    central or book an appointment via <a href="https://getsupport.apple.com" target="_blank">Apple support
                        system</a> to have a technician ready to discuss any issues
                    you may be facing when you arrive at the store. ( you will still have to leave the device behind with
                    us, the appointment only books the device in for diagnosis with our experienced and trained technicians)
                </p>

                <p>All Apple hardware repairs are completed using genuine parts.</p>

                <p>Unsure if your device is still under warranty, <a
                        href="https://checkcoverage.apple.com/unsupported?fromInterceptor=true" target="_blank">check the
                    warranty status.</a></p>

                <p><strong>Nutron</strong> can facilitate most <a href="https://support.apple.com/en-nz/exchange_repair"
                                                                  target="_blank">current repair or exchange programs</a>
                    active in New Zealand by
                    Apple in
                    accordance to Apple's repair program guidelines. Check if you are might be eligible.</p>

            </section>
           <service-enquiry-content class="hide-on-mobile" />
           <service-enquiry-content-mobile class="show-on-mobile" />
        </section>
        <ServiceEnquiry />
    </section>
</template>

<script>
    import LayoutDefault from "@/layouts/LayoutDefault";
    import ServiceEnquiry from "@/components/ServiceEnquiry";
    import ServiceEnquiryContent from "@/components/shared/ServiceEnquiryContent";
    import ServiceEnquiryContentMobile from "@/components/shared/ServiceEnquiryContentMobile";

    export default {
        components: {ServiceEnquiry, ServiceEnquiryContent, ServiceEnquiryContentMobile},
        created() {
            this.$emit('update:layout', LayoutDefault);
            this.$root.$emit('closenav', false);
        }
    }
</script>

<style lang="scss" scoped>
    $blue_color: #1d498e !important;
    .services {
        p {
            line-height: 34px;
            color: #666;
        }

        a {
            color: $blue_color;
            font-weight: bold;
        }

        .tabs {
            h3 {
                font-size: 1.1rem;
                font-weight: bold;
                color: #000;
            }

            .el-tabs__nav {
                .el-tabs__item {
                    text-align: left !important;
                    padding: 0 10px 0 0 !important;
                    color: $blue_color;
                    font-size: 14px;
                }
            }

            .el-tabs__content {
                div {
                    padding: 0 20px;
                }
            }

            .ol {
                padding-inline-start: 60px;
            }
        }
    }

</style>